<template lang="pug" src="./remove-dialog.pug"> </template>
<style lang="scss" src="./remove-dialog.scss" scoped> </style>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        removePhotoReportid: {
            type: Number,
            default: null
        }
    },
    computed: {
        removeDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        closeRemoveDialog() {
            this.removeDialog = false;
        },
        removePhotoReport() {
            this.$store.dispatch('photoReports/removePhotoReport', this.removePhotoReportid);
            this.closeRemoveDialog();
        }
    }
};
</script>
